import React, { useState } from 'react';
import axios from 'axios';
import { Card, Button, Typography, Row, Col, Space, Modal, message, InputNumber } from 'antd';
import { PlusOutlined, DeleteOutlined, InboxOutlined, DropboxOutlined } from '@ant-design/icons';
import PesquisarProdutosXml from './PesquisarProdutosXml';
import { useConfigQuery } from '../../../../queries/useConfig';
import { api } from '../../../../config/api';

const { Text, Title } = Typography;
const accessToken = window.localStorage.getItem("accessToken");
const badgeStyle = {
  fontSize: 14,
  fontWeight: 'bold',
  color: '#155724',
  backgroundColor: '#d4edda',
  padding: '4px 8px',
  borderRadius: '12px',
  display: 'inline-block',
  minWidth: '80px',
  textAlign: 'center',
};

const RelacaoProdutos = ({ closeModal, produto, idLoja, onSave, handleFileUpload }) => {

  const { data: config, error } = useConfigQuery();
  const [isPesquisar, setIspesquisar] = useState(false);
  const [isPesquisarParaEmbalagem, setIspesquisarParaEmbalagem] = useState(false);
  const [quantidade, setQuantidade] = useState(false);
  const [isLoading, setIsLoading] = useState(false);



  const vincularProduto = async (produtoPesquisado) => {
    console.log(produtoPesquisado);
    const payload = {
      idProdCprod: produto.cProd,
      idProd: produtoPesquisado.id,
      cnpjXml: produto.cnpj,
      idLoja: idLoja,
    };
    console.log(payload);


    try {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + accessToken,
        },
      };
      const resp = await axios.post(
        `${api.techspdv}/v1/referencias-entrada`,
        payload, options
      );
      setIspesquisar(false);
      if (resp.status == 200) {
        const produtoAtualizado = {
          ...produto,
          encontradoVia: 'CPROD',
          nomeSistema: produtoPesquisado.nome,
          id: produtoPesquisado.id,
          custo: produto.vProd,
        };

        onSave?.(produtoAtualizado);
        message.success('Produto vinculado com sucesso!');
        closeModal();
      } else {
        message.info('Falha ao vincular o produto!');
      }


    } catch (error) {
      message.error('Erro ao vincular produto.');
      console.error(error);
    }
  };

  const criarEmbalagem = async (produtoPesquisado) => {
    const embalagem = await criarNovaEmbalagem(produtoPesquisado.id);
    if (embalagem) {
      const produtoAtualizado = {
        ...produto,
        encontradoVia: 'EAN',
        nome: produtoPesquisado.nome,
        id: produtoPesquisado.id,
        custo: produto.custo / embalagem.data.qtd,
        quantidade: embalagem.data.qtd,
        ean: produtoPesquisado.ean,
        preco: produto.preco / embalagem.data.qtd
      };

      console.log(produtoAtualizado);
      onSave?.(produtoAtualizado);
      message.success('Produto vinculado com sucesso!');
      closeModal();
    }
    console.log(embalagem.data);
    console.log(produto);

  };

  const criarNovaEmbalagem = async (idProduto) => {
    try {
      const options = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      };
      setIsLoading(true);
      const payload = {
        barras: produto.ean,
        descricao: produto.nome,
        qtd: quantidade,
        custo: 0,
        preco: 0,
        idProduto: idProduto,
      };

      return await axios.post(
        `${api.techspdv}/v1/${config.idLoja}/embalagens`,
        payload,
        options
      );



    } catch (err) {
      console.error(err);
      message.error("Erro ao salvar!");
      setIsLoading(false);
    }

  }


  const removerVinculo = async () => {

    try {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + accessToken,
        },
      };

      console.log(`${api.techspdv}/v1/referencias-entrada/${idLoja}/${produto.cProd}`);

      const resp = await axios.delete(
        `${api.techspdv}/v1/referencias-entrada/${idLoja}/${produto.cProd}`,
        options
      );


      setIspesquisar(false);
      if (resp.status == 204) {
        produto.encontradoVia = '';
        message.success('Produto desvinculado com sucesso!');
        closeModal();
      } else {
        message.info('Falha ao desvincular o produto!');
      }


    } catch (error) {
      message.error('Erro ao desvincular produto.');
      console.error(error);
    }
  };

  const renderCardContent = (tipo) => {
    const isActive = produto.encontradoVia === tipo;

    return (

      <>
        <Col span={24} style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Text>XML: {isActive ? `${produto.cProd}-${produto.nome}` : ''}</Text>
          {tipo === 'CPROD' ? (
            <div>
              <Button
                type="default"
                icon={<PlusOutlined />}
                style={{ backgroundColor: 'black', color: 'white' }}
                disabled={isActive}
                onClick={() => setIspesquisar(true)}
              />
              <Button type="primary" style={{ backgroundColor: 'red', color: 'white' }} icon={<DeleteOutlined />} onClick={removerVinculo} disabled={!isActive} />
            </div>
          ) : <div>
            <Space>
              <InputNumber
                style={{ width: 120 }}
                placeholder="Qtd"
                value={quantidade}
                onChange={(v) => setQuantidade(v)}
                min={0}
                step={0.1}
                formatter={(value) =>
                  value === undefined || value === null || value === ''
                    ? ''
                    : String(value)
                      .replace('.', ',')
                      .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                }
                parser={(value) =>
                  value
                    ?.replace(/\./g, '') // remove milhar
                    .replace(',', '.')   // vírgula → ponto
                }
              />

              <Button
                type="default"
                icon={<InboxOutlined />}
                style={{ backgroundColor: "black", color: "white" }}
                disabled={isActive || quantidade <= 0}
                onClick={() => setIspesquisarParaEmbalagem(true)}
              />
            </Space>
          </div>}
        </Col>
        <Col span={24}>
          <Text>
            CATÁLOGO: {isActive ? `${produto.codigoDeIntegracao ? produto.codigoDeIntegracao : ''} - ${produto.nomeSistema}` : ''}
          </Text>
        </Col>
      </>
    );
  };

  return (
    isPesquisar ? <PesquisarProdutosXml
      onItemPress={vincularProduto}
      closeModal={() => setIspesquisar(false)}
      validarEstoque={false}

    /> : isPesquisarParaEmbalagem ? <PesquisarProdutosXml
      onItemPress={criarEmbalagem}
      closeModal={() => setIspesquisarParaEmbalagem(false)}
      validarEstoque={false}

    /> :
      <div style={{ maxWidth: 600, margin: '0 auto', padding: 24 }}>
        <Title level={4} style={{ textAlign: 'center' }}>
          {produto.nome}
          <br />    <br />
          LINK / RELAÇÃO DOS PRODUTOS
        </Title>
        <Button
          type="primary"
          onClick={closeModal}
          style={{ backgroundColor: 'black', borderColor: 'black' }}
        >
          Voltar
        </Button>

        {/* EAN */}
        <Card
          title={
            <Space>
              <Text strong>LINK:</Text>
              <span style={badgeStyle}>EAN</span>
              <Text>{produto.ean}</Text>
            </Space>
          }
          style={{ marginBottom: 16 }}
        >
          <Row gutter={[16, 8]}>{renderCardContent('EAN')}</Row>
        </Card>

        {/* CPROD */}
        <Card
          title={
            <Space>
              <Text strong>LINK:</Text>
              <span style={badgeStyle}>CPROD</span>
            </Space>
          }
        >
          <Row gutter={[16, 8]}>{renderCardContent('CPROD')}</Row>
        </Card>
      </div>
  );
};

export default RelacaoProdutos;
